let _base = window.location.href.toString().split("/");
const base = _base[0]+"//"+_base[2]+"/";

export const AppConfig = {
    baseUrl : base,
    pages:{
        cctv:base+"cctv",
        login:base+"login",
        admin : {
            home:base+"admin/",
            operators:base+"admin/operators",
            newOperator:base+"admin/new_operator",
            editOperator:base+"admin/edit_operator",
            machines:base+"admin/machines",
            department:base+"admin/department",
            call:base+"admin/call",
            calls:base+"admin/calls",
            assignCall:base+"admin/assign_call",
            reports:base+"admin/reports"
        },
        report : {
            reportBase:base+"admin/report",
            userAndFinishedWork:base+"admin/report?name=reportUserAndFinishedWork",
            reportUserStatistics:base+"admin/report?name=userWorkReport"
        }
    },
     // server:"http://192.168.1.10:51525/",
    // server:"http://84.17.89.127:50501/",
    server:"http://cagritakip.teknorot.com:50503/",
    service:{
        cctv: {
            troubleAll: "trouble/all",
            activeCall: "callings/active"
        },
        admin: {
            login: "users/auth",
            users: "users",
            userGet: "admin/get/user",
            userEdit: "admin/update/user",
            department: "users/units",
            callTypes: "users/types",
            troubleWaiting: "trouble/all/waiting",
            idleCallAvailableOperator: "admin/list/idleCallAvailableOperator",
            assignCall:"admin/assign/call",
        },
        report: {
            reportUserAndFinishedWork: "report/reportUserAndFinishedWork"
        }
    },
    cookie:{
        name:"gq4f446b#",
        surname:"glb.424_",
        token:"qfg35gg3",
        expires:7
    },
    cctv:{
        refreshMs : 3000
    },
    auth: {
        type : "Bearer"
    }
};
